import { useServices } from 'app/hooks.ts';
import { useWidgetContext } from 'widgets/WidgetContext.tsx';
import { useCallback, useEffect, useMemo } from 'react';

export const useImpactModel = () => {
    const { impactModelService } = useServices();
    const { widgetType, widgetKey } = useWidgetContext();

    const register = useCallback(() => {
        impactModelService.register(widgetType, widgetKey);
    }, [impactModelService, widgetType, widgetKey]);

    const deregister = useCallback(() => {
        impactModelService.deregister(widgetType, widgetKey);
    }, [impactModelService, widgetType, widgetKey]);

    useEffect(() => {
        return () => {
            deregister();
        };
    }, [deregister]);

    return useMemo(() => ({ deregister, register }), [deregister, register]);
};
